"use strict";

var HaikuDOMAdapter = require('@haiku/core/dom');
module.exports = HaikuDOMAdapter(require("./code"));